import { Route, Routes, Navigate } from 'react-router-dom';
import MetroRoadmap from './metro/MetroRoadmap';
import BoldStepsCanvas from './bold-steps/BoldStepsCanvas';
import GoalOrientedRoadmap from './goal-oriented/GoalOrientedRoadmap';
import FunctionalRoadmap from './functional/FunctionalRoadmap';
import GoalDrivenRoadmap from './goal-driven/GoalDrivenRoadmap';
import RoadmapLayout from './RoadmapLayout';
import RoadmapToolkitLayout from './RoadmapToolkitLayout';
import { RoadmapRedirect } from './RoadmapRedirect';

export function RoadmapToolkitRoutes() {
    return (
        <Routes>
            <Route element={<RoadmapToolkitLayout />}>
                <Route index element={<RoadmapRedirect />} />
                <Route path=":roadmapId" element={<RoadmapLayout />}>
                    <Route index element={<Navigate to="goal-oriented" replace />} />
                    <Route path="metro" element={<MetroRoadmap />} />
                    <Route path="bold-steps" element={<BoldStepsCanvas />} />
                    <Route path="goal-oriented" element={<GoalOrientedRoadmap />} />
                    <Route path="functional" element={<FunctionalRoadmap />} />
                    <Route path="goal-driven" element={<GoalDrivenRoadmap />} />
                </Route>
            </Route>
        </Routes>
    );
}

export default RoadmapToolkitRoutes;
